import axios from 'axios';
import { MAX_FILE_MB, MAX_FILE_SIZE, API_BASE_URL } from "../../constant/constant";
import { PDFDocument } from 'pdf-lib';



export const handleFileUploadWithSignedURL = async (file) => {
  try {
    const isValid = await filterCorruptFile(file);
    if (!isValid) {
      throw new Error(`Corrupted file detected: ${file.name}`);
    }
    const newFileName = file.name.replace(/\s+/g, "-");
    const newFile = new File([file], newFileName, { type: file.type });
    const largeFile = newFile.size > MAX_FILE_SIZE;
    if (largeFile) {
      throw new Error(`File size exceeds ${MAX_FILE_MB}MB`);
    }

    const userId = localStorage.getItem('id');
    const response = await axios.get(`${API_BASE_URL}/api/auth/get-signed-url`, {
      params: { userId, fileName: newFile.name },
    });
    if (response.data && response.data.signedUrl) {
      const result = await axios.put(response.data.signedUrl, newFile, {
        headers: {
          "Content-Type": newFile.type,
        },
      });
      if (result.status === 200) {
        return {
          fileUrl: response.data.key,
          fileName: newFile.name,
          fileSize: newFile.size,
          uploadTime: new Date().toISOString(),
        };
      } else {
        throw new Error("Error uploading file");
      }
    }
  } catch (error) {
    throw error.message
  }

}
export const filterCorruptFile = async (file) => {
  const fileType = file.type;
  if (fileType === 'application/pdf') {
    return isReadablePDF(file);
  } else {
    return true; // Assume non-PDF files are not corrupted
  }
}

// 🔍 Try to load the PDF with pdf-lib — fails if corrupted
const isReadablePDF = async (file) => {
  try {
    const arrayBuffer = await file.arrayBuffer();
    await PDFDocument.load(arrayBuffer, { ignoreEncryption: true });
    return true;
  } catch (error) {
    console.error(`Corrupted PDF detected: ${file.name}`, error);
    return false;
  }
};